import React from 'react';
import { getAuthLocalStorage } from '../../../storage/localStorage';
import AdminLayout from '../adminLayout';
import SellerLayout from '../sellerLayout';

/**
 * SmartLayout - Chooses layout based on user type
 * For sellers with assigned admin menus, uses SellerLayout
 * For admin/sub-admin, uses AdminLayout
 */
export default function SmartLayout({ children }) {
  const auth = getAuthLocalStorage();
  const userType = (auth?.userType || localStorage.getItem('userType') || '').toLowerCase();
  
  // console.log('[SmartLayout] auth:', auth);
  // console.log('[SmartLayout] userType:', userType);
  
  // Sellers always use SellerLayout (even for admin pages they have access to)
  if (userType === 'seller') {
    // console.log('[SmartLayout] Using SellerLayout for seller');
    return <SellerLayout>{children}</SellerLayout>;
  }
  
  // Admin and sub-admin use AdminLayout
  // console.log('[SmartLayout] Using AdminLayout for admin/sub-admin');
  return <AdminLayout>{children}</AdminLayout>;
}
